/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../root'
import { RcmTable } from '../../../components/rcm-table/RcmTable'
import { TableHeadRow, TableHeadCell, TableRow } from '../../../components/table/TableComponents'
import { createDateTimeFormatter } from '../../../utils/commonColumns'
import TableMenu from './TableMenu'

interface WorkflowTemplatesTableProps {
  onRowClick: (template: any) => void
  onDeleteSuccess?: () => void
  onExportStart?: () => void
  onExportEnd?: () => void
}

const WorkflowTemplatesTable: React.FC<WorkflowTemplatesTableProps> = ({
  onRowClick,
  onDeleteSuccess,
  onExportStart,
  onExportEnd
}) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  const formatDateTime = createDateTimeFormatter(context.service.auth, translate)

  return (
    <RcmTable
      className="chita-table"
      noResultsText={translate('NO_RESULTS_FILTERED')}
      HeadRow={
        <TableHeadRow className="has-actions">
          <TableHeadCell style={{ fontSize: '12px' }} sort="NAME">
            {translate('NAME')}
          </TableHeadCell>
          <TableHeadCell style={{ fontSize: '12px' }} id="40a08345-f9d6-4f36-a748-5c38e320dbba">
            {translate('DESCRIPTION')}
          </TableHeadCell>
          <TableHeadCell style={{ fontSize: '12px' }} sort="CREATED_AT">
            {translate('CREATED_ON')}
          </TableHeadCell>
          <TableHeadCell style={{ fontSize: '12px' }} sort="CREATED_BY">
            {translate('CREATED_BY')}
          </TableHeadCell>
          <TableHeadCell style={{ fontSize: '12px' }} sort="UPDATED_AT">
            {translate('TABLE_TH_MODIFIED_ON')}
          </TableHeadCell>
          <TableHeadCell style={{ fontSize: '12px' }} sort="UPDATED_BY">
            {translate('TABLE_TH_MODIFIED_BY')}
          </TableHeadCell>
          <TableHeadCell style={{ fontSize: '12px' }} id="1bf9aedb-65d7-420a-bd44-29bd3a84777d" className="actions">
            {translate('ACTIONS')}
          </TableHeadCell>
        </TableHeadRow>
      }
      Row={({ row }: { row: any }) => {
        const item = row
        return (
          <TableRow key={item.id}>
            <td className="clipped-cell">
              <div className="ellipsis">
                {item.system ? (
                  item.name
                ) : (
                  <span className="btn-link" onClick={() => onRowClick(item)} style={{ cursor: 'pointer' }}>
                    {item.name}
                  </span>
                )}
              </div>
            </td>
            <td>{item.description || translate('NOT_AVAILABLE')}</td>
            <td>{formatDateTime(item.createdAt)}</td>
            <td>{item.createdBy?.name || translate('NOT_AVAILABLE')}</td>
            <td>{formatDateTime(item.updatedAt)}</td>
            <td>{item.updatedBy?.name || translate('NOT_AVAILABLE')}</td>
            <td className="actions">
              <TableMenu
                item={item}
                onEdit={() => onRowClick(item)}
                onDeleteSuccess={onDeleteSuccess}
                onExportStart={onExportStart}
                onExportEnd={onExportEnd}
              />
            </td>
          </TableRow>
        )
      }}
    />
  )
}

export default WorkflowTemplatesTable
